import { CSS, StyleProps } from "@shared/primitive-components"

export const marginBottom = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(4),
})

export const tooltipContent = (): CSS => ({
  maxWidth: `200px`,
})

export const separator = (props: StyleProps): CSS => ({
  marginTop: props.theme.spacing(2),
  marginBottom: props.theme.spacing(0),
})

export const scoreContainer = (): CSS => ({
  position: `absolute`,
  left: `50%`,
  top: `49%`,
  transform: `translateX(-50%)`,
  display: `flex`,
  flexDirection: `column`,
  alignItems: `center`,
  justifyContent: `center`,
})

export const gauge = (): CSS => ({
  position: `relative`,
  display: `flex`,
  alignItems: `center`,
  justifyContent: `center`,
})

export const noData = (props: StyleProps): CSS => ({
  marginTop: props.theme.spacing(2),
  marginBottom: props.theme.spacing(2),
  paddingLeft: props.theme.spacing(2),
  paddingRight: props.theme.spacing(2),
  textAlign: `left`,
})
